import { api } from './api';

export const fetchCreateBH = (payload) => {
  return api.post('/rules/business_hours_rules_set', payload);
};

export const fetchBusinessHoursById = (id) => {
  return api.get(`/rules/business_hours_rules_set/${id}`);
};

export const fetchBusinessHoursList = (params) => {
  return api.get(`/rules/business_hours_rules_set`, params);
};

export const fetchAssociatedVehicleGroups = (id, params) => {
  return api.get(`/rules/business_hours_rules_set/${id}/vehicle_group`, params);
};

export const fetchOverwriteBH = (id, payload) => {
  return api.post(`/rules/business_hours_rules_set/${id}/overwrite`, payload);
};

export const fetchUpdateBusinessHours = (id, payload) => {
  return api.put(`/rules/business_hours_rules_set/${id}`, payload);
};
